import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WelcomeHeader = () => {
  const handleSignInClick = () => {
    window.location.href = '/customer-login';
  };

  const handleAgentSignupClick = () => {
    window.location.href = '/agent-registration';
  };

  return (
    <div className="text-center space-y-6">
      {/* Logo and Brand */}
      <div className="flex items-center justify-center space-x-3 mb-6">
        <img
          src="/assets/images/No_Background-1763506485544.png"
          alt="HoliYay logo featuring a friendly fox mascot with Scottish heritage"
          className="h-12 w-auto"
        />
        <div>
          <h1 className="text-3xl font-bold text-foreground">HoliYay</h1>
          <p className="text-sm text-muted-foreground">Travel, simplified. Yay, amplified.</p>
        </div>
      </div>

      {/* Welcome Message */}
      <div className="space-y-3">
        <h2 className="text-2xl font-semibold text-foreground">
          Start Your Dream Holiday Journey
        </h2>
        <p className="text-muted-foreground max-w-md mx-auto">
          Join thousands of travelers who've found their perfect holiday through our network of verified travel experts.
        </p>
      </div>

      {/* Benefits Highlight */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
        <div className="flex flex-col items-center space-y-2 p-4">
          <div className="w-10 h-10 bg-accent/20 rounded-full flex items-center justify-center">
            <Icon name="Search" size={20} className="text-accent" />
          </div>
          <h3 className="font-medium text-foreground">Find Experts</h3>
          <p className="text-xs text-muted-foreground text-center">
            Connect with verified travel agents who specialize in your dream destination
          </p>
        </div>
        
        <div className="flex flex-col items-center space-y-2 p-4">
          <div className="w-10 h-10 bg-accent/20 rounded-full flex items-center justify-center">
            <Icon name="MessageCircle" size={20} className="text-accent" />
          </div>
          <h3 className="font-medium text-foreground">Get Proposals</h3>
          <p className="text-xs text-muted-foreground text-center">
            Receive personalized travel proposals tailored to your budget and preferences
          </p>
        </div>
        
        <div className="flex flex-col items-center space-y-2 p-4">
          <div className="w-10 h-10 bg-accent/20 rounded-full flex items-center justify-center">
            <Icon name="Plane" size={20} className="text-accent" />
          </div>
          <h3 className="font-medium text-foreground">Book & Travel</h3>
          <p className="text-xs text-muted-foreground text-center">
            Choose your favorite proposal and let experts handle all the details
          </p>
        </div>
      </div>

      {/* Alternative Actions */}
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <span>Already have an account?</span>
          <Button
            variant="link"
            size="sm"
            onClick={handleSignInClick}
            className="p-0 h-auto font-medium"
          >
            Sign In
          </Button>
        </div>
        
        <div className="hidden sm:block w-px h-4 bg-border"></div>
        
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <span>Travel professional?</span>
          <Button
            variant="link"
            size="sm"
            onClick={handleAgentSignupClick}
            className="p-0 h-auto font-medium text-primary"
          >
            Join as Agent
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;